
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./auth.css";

export default function AdminLogin() {

  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const loginAdmin = async (e) => {

    e.preventDefault();

    try {

      const res = await axios.post(
        "https://apple2.shopat1stop.com/api/login",
        {
          email,
          password
        }
      );

      // SAVE LOGIN
      localStorage.setItem(
        "token",
        res.data.token
      );

      localStorage.setItem(
        "role",
        res.data.role
      );

      localStorage.setItem(
        "user_id",
        res.data.user_id
      );

      localStorage.setItem(
        "name",
        res.data.name
      );

      // CHECK ADMIN
      if (res.data.role !== "admin") {

        alert("Admin Access Only ❌");

        return;
      }

      alert("Admin Login Success ✅");

      navigate("/admin-dashboard");

    } catch (err) {

      alert(
        err.response?.data?.message ||
        "Login Failed ❌"
      );
    }
  };

  return (

    <div className="auth-page">

      <form
        className="auth-form"
        onSubmit={loginAdmin}
      >

        <h2>Admin Login</h2>

        <input
          type="email"
          placeholder="Admin Email"
          value={email}
          onChange={(e) =>
            setEmail(e.target.value)
          }
          required
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) =>
            setPassword(e.target.value)
          }
          required
        />

        <button type="submit">
          Login As Admin
        </button>

      </form>

    </div>
  );
}